import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
            Shop by Category
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 md:mt-3 max-w-md">
            Browse our complete collection across 14 product categories powered by the{' '}
            <strong className="text-foreground-800">itaobuyspreadsheet</strong> system.
          </p>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              {/* Image container */}
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category - itaobuy spreadsheet shopping`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 6 ? 'eager' : 'lazy'}
                />
              </div>

              {/* Card info */}
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-3">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  View Category
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}